<template>
  <div class="textlist">
    <div class="banner_container">
      <div class="banner_title">各类下载</div>
      <img
        src="~@/assets/images/listitem/pic-banner-course@2x.png"
        alt=""
        style="width: 100%; height: 100%"
      />
    </div>
    <div class="container_wrap">
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
        class="eltab"
      >
        <!-- <el-tab-pane label="各类管理办法" name="各类管理办法">
          <div class="tabpane_container">
            <text-list-item
              v-for="(item, index) in downListData"
              :key="index"
              :itemData="item"
            ></text-list-item>
          </div>
        </el-tab-pane>
        <el-tab-pane label="各类规程" name="各类规程">
          <div class="tabpane_container">
            <text-list-item
              v-for="(item, index) in downListData"
              :key="index"
              :itemData="item"
            ></text-list-item>
          </div>
        </el-tab-pane>
        <el-tab-pane label="各类章程" name="各类章程">
          <div class="tabpane_container">
            <text-list-item
              v-for="(item, index) in downListData"
              :key="index"
              :itemData="item"
            ></text-list-item>
          </div>
        </el-tab-pane>
        <el-tab-pane label="各类协议" name="各类协议">
          <div class="tabpane_container">
            <text-list-item
              v-for="(item, index) in downListData"
              :key="index"
              :itemData="item"
            ></text-list-item>
          </div>
        </el-tab-pane>
        <el-tab-pane label="各类登记表" name="各类登记表">
          <div class="tabpane_container">
            <text-list-item
              v-for="(item, index) in downListData"
              :key="index"
              :itemData="item"
            ></text-list-item>
          </div>
        </el-tab-pane> -->
        <el-tab-pane
          :label="item2.name"
          :name="item2.name"
          v-for="(item2, index2) in firstSecretaryTitleList"
          :key="index2"
        >
          <div class="tabpane_container">
            <text-list-item
              v-for="(item, index) in downListData"
              :key="index"
              :itemData="item"
            ></text-list-item>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import TextListItem from "@/components/listItem/TextListItem";
export default {
  name: "TextList",
  data() {
    return {
      activeName: "各类管理办法",
      downListData: [],
      CateListBYId: 100,
      // judgeArr: [
      //   { idDown: 100, name: "各类管理办法" },
      //   { idDown: 101, name: "各类规章" },
      //   { idDown: 102, name: "各类章程" },
      //   { idDown: 103, name: "各类协议" },
      //   { idDown: 104, name: "各类登记表" },
      // ],
      firstSecretaryTitleList: [],
    };
  },
  mounted() {
    this.getFirstTab();
    this.handleSecondTabDefault();
  },
  methods: {
    //处理第二级tab网址进入的初始情况
    handleSecondTabDefault() {
      var that = this;
      setTimeout(function (res) {
        that.firstSecretaryTitleList.some(function (item) {
          if (item.idDown == parseInt(that.$route.query.idDown)) {
            that.activeName = item.name;
          }
        });
        that.handleClick();
      }, 150);
    },
    //获取二级tab
    getFirstTab() {
      // http://api.eaechina.net/api/cms/catelist?parent_id=93
      const that = this;
      that.$api.get(
        "/api/cms/catelist",
        {
          parent_id: 99, //99 二级tab的父级
        },
        (res) => {
          // this.$message.success("发送成功");
          that.firstSecretaryTitleList = res.data;
          for (var i = 0; i < that.firstSecretaryTitleList.length; i++) {
            that.firstSecretaryTitleList[i].idDown =
              that.firstSecretaryTitleList[i].id;
          }
          console.log(
            "that.firstSecretaryTitleList",
            that.firstSecretaryTitleList
          );
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    //tab点击事件
    handleClick() {
      var that = this;
      that.firstSecretaryTitleList.some(function (item) {
        if (that.activeName == item.name) {
          that.CateListBYId = item.idDown;
        }
      });
      this.getDownList();
    },
    getDownList() {
      var that = this;
      that.$router.push({
        path: "/cate",
        query: { id: that.CateListBYId, idDown: that.CateListBYId },
      });
      that.$api.get(
        "/api/cms/helplist",
        {
          cate_id: that.CateListBYId,
          step: 20,
          status: 1,
        },
        (res) => {
          // this.$message.success("发送成功");
          //   that.driverLine = res.data.list[0].content;
          that.downListData = res.data.list;
          // console.log("that.downListData",that.downListData)
          // that.cateData = res.data[0].tpl;
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
  },
  components: {
    TextListItem,
  },
  watch: {
    $route: {
      handler() {
        var that = this;
        // console.log("this.$route.query.id", this.$route.query.id);
        setTimeout(function () {
          that.firstSecretaryTitleList.some(function (item) {
            if (item.idDown == parseInt(that.$route.query.id)) {
              that.activeName = item.name;
            }
          });
        }, 500);
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="scss">
.textlist {
  min-height: 1235px;
  background: #f4faff;
}
.banner_container {
  height: 318px;
  width: 100%;
  background: #f4faff;
  position: relative;
  .banner_title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1240px;
    font-size: 48px;
    font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
      "\5FAE\8F6F\96C5\9ED1";
    font-weight: 400;
    color: #ffffff;
  }
}
.container_wrap {
  background: #f4faff;
}

.eltab {
  width: 1240px;
  margin: 0 auto;
  margin-top: -65px;
  /deep/.el-tabs__header {
    margin: 0;
    border: none;
    /deep/.el-tabs__nav-wrap {
      padding-left: 0;
      /deep/.el-tabs__nav-scroll {
        /deep/.el-tabs__nav {
          border: none;
          display: flex;
          align-items: flex-end;
          /deep/.el-tabs__item {
            box-shadow: none;
            width: 230px;
            height: 89px;
            background: #ff8d3a;
            box-shadow: 0px 0px 16px 2px rgba(43, 81, 149, 0.3);
            border-radius: 32px 32px 0px 0px;
            font-size: 24px;
            font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
              "\5FAE\8F6F\96C5\9ED1";
            font-weight: 500;
            color: #ffffff;
            line-height: 89px;
            text-align: center;
            margin-right: 8px;
            border-left: none;
          }
          /deep/.is-active {
            height: 107px;
            line-height: 127px;
            background: #ffffff;
            color: #333333;
            box-shadow: 0px 0px 16px 2px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
  /deep/.el-tabs__content {
    width: 1240px;
    min-height: 690px;
    background: #ffffff;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 48px 48px;
  }
  .tabpane_container {
    padding: 26px 0 0 0;
  }
}
/deep/.eltab >>> .el-tabs__header >>> .el-tabs__nav-wrap {
  padding: 0;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll {
  overflow: auto;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav {
  border: none;
  display: flex;
  align-items: flex-end;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .el-tabs__item {
  box-shadow: none;
  width: 230px;
  height: 89px;
  background: #ff8d3a;
  box-shadow: 0px 0px 16px 2px rgba(43, 81, 149, 0.3);
  border-radius: 32px 32px 0px 0px;
  font-size: 24px;
  font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
    "\5FAE\8F6F\96C5\9ED1";
  font-weight: 500;
  color: #ffffff;
  line-height: 89px;
  text-align: center;
  margin-right: 25px;
  border-left: none;
  margin-right: 8px;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .is-active {
  height: 107px;
  line-height: 127px;
  background: #ffffff;
  color: #333333;
  box-shadow: 0px 0px 16px 2px rgba(0, 0, 0, 0.1);
}
/deep/.eltab >>> .el-tabs__content {
  width: 1240px;
  min-height: 690px;
  background: #ffffff;
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0px 0px 48px 48px;
}
/deep/.eltab >>> .el-tabs__header {
  margin: 0;
  border: none;
}
</style>


// WEBPACK FOOTER //
// TextList.vue?1633e45c